import React from 'react'
import Structure from '../components/layout/Structure'

const Portfolio = () => {
  return (
    <Structure>
      Portfolio
    </Structure>
  )
}

export default Portfolio